import { render } from "./PrintInvoiceMoneyDetailsDesign3.vue?vue&type=template&id=56c132b8"
import script from "./PrintInvoiceMoneyDetailsDesign3.vue?vue&type=script&lang=js"
export * from "./PrintInvoiceMoneyDetailsDesign3.vue?vue&type=script&lang=js"

import "./PrintInvoiceMoneyDetailsDesign3.vue?vue&type=style&index=0&id=56c132b8&scoop=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__